// extracted by mini-css-extract-plugin
module.exports = {"optionIcon":"src-components-MaterialComponents-MaterialCheckIconComponent-index-module__optionIcon--2va-u"};